import React from 'react';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import { Box, createTheme, Grid, ThemeProvider } from '@mui/material';
import Header from './components/UI/Header/Header';
import YourMeals from './pages/Meal/YourMeals';
import YourMenu from './pages/YourMenu';
import NewMeal from './pages/Meal/NewMeal';
import MealDetail from './pages/Meal/MealDetail';
import MealDetailEdit from './pages/Meal/MealDetailEdit';
import CookWithWhatIHave from './pages/CookWithWhatIHave';
import RecipeManagement from './pages/RecipeManagement';
import CookingGuidance from './pages/CookingGuidance';
import CookingGuidanceResults from './pages/CookingGuidanceResults';
import CookingGuidanceByCuisine from './pages/CookingGuidanceByCuisine';
import CookingGuidanceByType from './pages/CookingGuidanceByType';
import MealPlansPage from './pages/MealPlan/MealPlans';
import MealPlanDetailPage from './pages/MealPlan/MealPlanDetail';
import NewMealPlanPage from './pages/MealPlan/NewMealPlan';
import ShoppingListPage from './pages/ShoppingList/ShoppingList';
import InstallPrompt from './components/UI/InstallPrompt';

const theme = createTheme({
  palette: {
    primary: {
      main: '#86de69',
    },
    secondary: {
      main: '#a68b6b',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Header />
        </Grid>
        <Grid item xs={12}>
          <Box padding={theme.spacing(1, 2)}>
            <Routes>
              <Route index element={<Home />} />
              <Route path="/your-menu" element={<YourMenu />} />
              <Route path="/your-meals" element={<YourMeals />} />
              <Route path="/new-meal" element={<NewMeal />} />
              <Route path="/meal-detail/:mealId" element={<MealDetail />} />
              <Route path="/meal-detail/:mealId/edit" element={<MealDetailEdit />} />
              <Route path="/cook-with-what-i-have" element={<CookWithWhatIHave />} />
              <Route path="/recipe-management" element={<RecipeManagement />} />
              <Route path="/cooking-guidance" element={<CookingGuidance />} />
              <Route path="/cooking-guidance/by-cuisine" element={<CookingGuidanceByCuisine />} />
              <Route path="/cooking-guidance/by-type" element={<CookingGuidanceByType />} />
              <Route path="/cooking-guidance/:filter" element={<CookingGuidanceResults />} />
              <Route path="/meal-plans" element={<MealPlansPage />} />
              <Route path="/meal-plan/new" element={<NewMealPlanPage />} />
              <Route path="/meal-plan/:id" element={<MealPlanDetailPage />} />
              <Route path="/shopping-list" element={<ShoppingListPage />} />
            </Routes>
          </Box>
        </Grid>
      </Grid>
      <InstallPrompt />
    </ThemeProvider>
  );
}

export default App;
